import { supabase } from "./supabase";
import type { UserProfile } from "./roles";

type ApiResult<T> = {
  success: boolean;
  data?: T;
  error?: string;
};

async function getAccessToken(): Promise<string | null> {
  const { data } = await supabase.auth.getSession();
  return data.session?.access_token ?? null;
}

export async function apiFetch<T>(path: string, init: RequestInit = {}): Promise<ApiResult<T>> {
  const token = await getAccessToken();
  const headers = new Headers(init.headers);
  headers.set("content-type", "application/json");
  if (token) headers.set("authorization", `Bearer ${token}`);

  const response = await fetch(path, { ...init, headers });
  const payload = (await response.json().catch(() => ({}))) as ApiResult<T>;

  if (!response.ok) {
    return {
      success: false,
      error: payload.error || `Request failed with status ${response.status}`
    };
  }

  return payload;
}

export function fetchCurrentProfile() {
  return apiFetch<UserProfile>("/api/me");
}
